import { render, staticRenderFns } from "./CookieWindow.vue?vue&type=template&id=2fd180d6&scoped=true"
import script from "./CookieWindow.vue?vue&type=script&lang=js"
export * from "./CookieWindow.vue?vue&type=script&lang=js"
import style0 from "./CookieWindow.vue?vue&type=style&index=0&id=2fd180d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd180d6",
  null
  
)

export default component.exports